import { initBoostPfs } from "./boost-pfs";
import { initContentsquare } from "./contentsquare";
import { initGtm } from "./gtm";
import { initJudgeMe } from "./judge-me";
import { initPagefly } from "./pagefly";
import { initRebuy } from "./rebuy";
import { initTimesact } from "./timesact";
import type { TemplateName } from "../types/route-context";

let initialized = false;

const PROTECTED_TEMPLATES = new Set<TemplateName>(["password", "gift_card"]);
const BOOST_TEMPLATES = new Set<TemplateName>(["collection", "search"]);
const TIMESACT_TEMPLATES = new Set<TemplateName>(["product", "cart"]);

export function initIntegrations(template: TemplateName): void {
  if (initialized) {
    return;
  }

  initGtm();

  if (!PROTECTED_TEMPLATES.has(template)) {
    initContentsquare();
    initPagefly();
    initJudgeMe();
    initRebuy();
    if (TIMESACT_TEMPLATES.has(template)) {
      initTimesact();
    }
  }

  if (BOOST_TEMPLATES.has(template)) {
    initBoostPfs();
  }

  initialized = true;
}
